import gql from 'graphql-tag';

export interface OPENAI_DESCRIPTION_VAR {
  eventTypes: string[];
  eventTypeOtherInput: string | undefined;
  tones: string[];
  toneOtherInput: string | undefined;
  length: string;
  comment?: string;
  eventTitle?: string;
}

export const OPENAI_GENERATE_DESCRIPTION = gql`
  query (
    $eventTypes: [String]!
    $eventTypeOtherInput: String
    $tones: [String]!
    $toneOtherInput: String
    $length: String!
    $comment: String
    $eventTitle: String
  ) {
    generatedDescription(
      eventTypes: $eventTypes
      eventTypeOtherInput: $eventTypeOtherInput
      tones: $tones
      toneOtherInput: $toneOtherInput
      length: $length
      comment: $comment
      eventTitle: $eventTitle
    ) {
      answer
    }
  }
`;

export interface OPENAI_FEEDBACK_INSIGHTS_VAR {
  questionId: string;
  eventId: string;
}

export const OPENAI_GENERATE_FEEDBACK_INSIGHTS = gql`
  query ($questionId: String!, $eventId: String!) {
    generateFeedbackInsights(questionId: $questionId, eventId: $eventId) {
      answer
    }
  }
`;
